import { sleep } from './helpers'

export const WebSocketController: {
  websockets: {
    [key: string]: {
      socket: WebSocket
      callbacks: {
        callback: (data: any) => void
        name: string
      }[]
    }
  }
  recconnectIntervals: {
    [key: string]: NodeJS.Timeout
  }
  connectWebSocket: (
    host: string,
    channel: string,
    callback: (data: any) => void,
    callbackName?: string,
    onConnect?: () => void,
    onClose?: () => void
  ) => void
  disconnectWebSocket: (channel: string, callbackName?: string) => void
  closeAllSockets: () => void
} = {
  websockets: {},
  recconnectIntervals: {},

  connectWebSocket: function (
    host,
    channel,
    callback,
    callbackName = 'callback',
    onConnect = () => undefined,
    onClose = () => undefined
  ) {
    if (!this.websockets[channel]) {
      try {
        if (host.endsWith('/')) host = host.slice(0, -1)
        if (channel.startsWith('/')) channel = channel.slice(1)
        this.websockets[channel] = {
          callbacks: [
            {
              callback,
              name: callbackName
            }
          ],
          socket: new WebSocket(`${host}/${channel}`)
        }
        console.log(this.websockets)

        this.websockets[channel].socket.onmessage = (evt) => {
          try {
            this.websockets[channel].callbacks.forEach((x) => {
              x.callback(JSON.parse(evt.data))
            })
            // if (channel === 'position') timeLag(JSON.parse(evt.data))
          } catch (e: any) {
            console.error(
              `${channel} websocket ${callbackName} error ---`,
              e?.message
            )
            console.log(e)
          }
        }

        this.websockets[channel].socket.onclose = async (evt: CloseEvent) => {
          console.log(`${channel} websocket connection closed`)
          if (evt.code !== 3001) {
            const callbacks = this.websockets[channel]
              ? this.websockets[channel].callbacks
              : []
            delete this.websockets[channel]
            console.log(`${channel} websocket attempting to reconnect`)
            onClose()
            await sleep(2000)
            callbacks.forEach((x) => {
              this.connectWebSocket(
                host,
                channel,
                x.callback,
                x.name,
                onConnect,
                onClose
              )
            })
          }
        }

        this.websockets[channel].socket.onopen = () => {
          onConnect()
          console.log(`${channel} websocket connection opened`)
        }

        // Capture the socket this handler is bound to. The error event can fire
        // asynchronously after disconnectWebSocket/onclose has deleted (or a
        // reconnect has replaced) this.websockets[channel], so re-reading the
        // map slot here would throw or log the wrong socket.
        const erroringSocket = this.websockets[channel].socket
        erroringSocket.onerror = (err) => {
          console.error(`${channel} - WebSocket error:`, {
            url: erroringSocket.url,
            readyState: erroringSocket.readyState,
            error: err
          })
        }
      } catch (e: any) {
        console.error(e.message)
      }
    } else {
      if (
        !this.websockets[channel].callbacks.some((x) => x.name === callbackName)
      ) {
        this.websockets[channel].callbacks.push({
          callback,
          name: callbackName
        })
      }
    }
  },

  disconnectWebSocket: function (channel, callbackName = 'callback') {
    console.log(`${channel} websocket disconnecting`)
    if (this.websockets[channel]) {
      try {
        this.websockets[channel].callbacks = this.websockets[
          channel
        ].callbacks.filter((x) => x.name !== callbackName)
        if (this.websockets[channel].callbacks.length < 1) {
          this.websockets[channel].socket.close(3001)
          delete this.websockets[channel]
        }
      } catch (e: any) {
        console.error(e.message)
      }
    } else {
      console.log(`${channel} websocket connection not active`)
    }
  },

  closeAllSockets: function () {
    for (const channel in this.websockets) {
      this.websockets[channel].callbacks.forEach((x) => {
        this.disconnectWebSocket(channel, x.name)
      })
    }
  }
}
